/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React from 'react'
import PropTypes from 'prop-types'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import css from './index.module.scss'

function NextArrow ({
  className = '',
  style = null,
  onClick = () => {
  }
}) {
  return (
    <div
      className={`${className} ${css.nextArrow}`}
      style={{
        ...style,
        display: 'block'
      }}
      onClick={onClick}
      onKeyDown={onClick}
      role="button"
      tabIndex={0}
    >
      <div>
        <img
          alt=""
          src="/images/oval.png"
          height="50px"
          width="50px"
        />
      </div>
    </div>
  )
}

function PrevArrow ({
  className = '',
  style = null,
  onClick = () => {
  }
}) {
  return (
    <div
      className={`${className} ${css.preArrow}`}
      style={{
        ...style,
        display: 'block'
      }}
      onClick={onClick}
      onKeyDown={onClick}
      role="button"
      tabIndex={0}
    >
      <div
        className={css.rotate}
      >
        <img
          alt=""
          src="/images/oval.png"
          height="50px"
          width="50px"
        />
      </div>
    </div>
  )
}

const getResponsiveSettings = (breakpoints, listLength) =>
  breakpoints.map(({
    breakpoint,
    settings
  }) => {
    const cappedSlidesToShow = Math.min(settings.slidesToShow, listLength)
    return {
      breakpoint,
      settings: {
        ...settings,
        slidesToShow: cappedSlidesToShow,
        slidesToScroll: Math.min(settings.slidesToScroll, cappedSlidesToShow),
        infinite: listLength > cappedSlidesToShow
      }
    }
  })
/** @type {React.ForwardRefExoticComponent<any>} */
const SlickCarousel = React.forwardRef(function SlickCarousel (props, ref) { // CHANGED
  const {
    itemsPerCarousel,
    SliderItem,
    idField,
    list,
    slidesToScroll = 1, // noControl = false,
    interval = 5000,
    autoPlayInterval = 5000,
    showActiveDots = false,
    autoPlay = false,
    otherSettings = {},
    responsive = [],
    className = '',
    centerMode = false,
    arrows = true,
    slideItemProps = {}
  } = props
  const visibleSlides = Math.min(itemsPerCarousel, list.length)
  const settings = {
    dots: showActiveDots,
    className,
    slidesToShow: visibleSlides,
    slidesToScroll: Math.min(slidesToScroll, list.length),
    centerMode: list.length > visibleSlides ? centerMode : false,
    infinite: list.length > visibleSlides, // disable infinite when not enough items
    pauseOnHover: true,
    swipeToSlide: true,
    speed: interval,
    arrows,
    nextArrow: <NextArrow/>,
    prevArrow: <PrevArrow/>,
    autoplay: autoPlay,
    autoplaySpeed: autoPlayInterval,
    responsive: getResponsiveSettings(responsive, list.length),
    ...(otherSettings || {})
  }

  if (list.length <= visibleSlides) {
    return (
      <div className="overflow-x-auto no-scrollbar">
        {list.map((item) => (
          <SliderItem
            key={item[idField]}
            item={item}
            idField={idField}
            {...slideItemProps}
          />
        ))}
      </div>
    )
  }

  return (
    <Slider
      ref={ref} // CHANGED
      {...settings}
    >
      {
        list.map((item) => (
          <SliderItem
            key={item[idField]}
            item={item}
            itemsPerCarousel={itemsPerCarousel}
            idField={idField}
            className=""
            {...slideItemProps}
          />
        ))
      }
    </Slider>
  )
}) // CHANGED

NextArrow.propTypes = {
  className: PropTypes.string,
  style: PropTypes.shape({}),
  onClick: PropTypes.func
}

PrevArrow.propTypes = {
  className: PropTypes.string,
  style: PropTypes.shape({}),
  onClick: PropTypes.func
}

SlickCarousel.propTypes = {
  itemsPerCarousel: PropTypes.number.isRequired,
  SliderItem: PropTypes.oneOfType([
    PropTypes.element, PropTypes.func]).isRequired,
  idField: PropTypes.string.isRequired,
  list: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  slidesToScroll: PropTypes.number,
  interval: PropTypes.number,
  autoPlayInterval: PropTypes.number,
  noControl: PropTypes.bool,
  showActiveDots: PropTypes.bool,
  className: PropTypes.string,
  centerMode: PropTypes.bool,
  autoPlay: PropTypes.bool,
  otherSettings: PropTypes.shape({}),
  responsive: PropTypes.arrayOf(PropTypes.shape({})),
  arrows: PropTypes.bool,
  slideItemProps: PropTypes.shape({})
}

export default SlickCarousel
